import { Component, Input, OnInit } from '@angular/core';
import { TableHelper } from 'src/app/layout/shared/helper/table-helper';
import { BoardServiceService } from '../../services/board-service.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-times-list',
  templateUrl: './times-list.component.html',
  styleUrls: ['./times-list.component.scss']
})
export class TimesListComponent extends TableHelper implements OnInit {
  @Input() taskId: number;
  @Input() projectId: number;

  constructor(
    public translate: TranslateService,
    private boardService: BoardServiceService,
  ) {
    super();
  }

  ngOnInit(): void {
  }

  startTable() {
    this.loadDataObservable(this.boardService.getTimesList(this.pageSize, this.page, this.taskId, this.projectId));
  }

  searchData(){
    this.loadDataObservable(this.boardService.getTimesList(this.pageSize, this.page, this.taskId, this.projectId));
  }

  parseSeconds(secondsBackend: number) {
    if(secondsBackend > 0){

      let totalSeconds = secondsBackend;
      let hours = Math.floor(totalSeconds / 3600);
      totalSeconds %= 3600;
      let minutes = Math.floor(totalSeconds / 60);
      let seconds = totalSeconds % 60;
      return String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0")
    }else{
      return null; 
    }
  }


}
